var _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse9, _ellipse10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 282,
    viewBox: "0 0 279 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 176,
    cy: 199.188,
    rx: 103,
    ry: 71.5,
    fill: "#EFEFEF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.5,
    cy: 203.688,
    rx: 126.5,
    ry: 78,
    fill: "url(#paint0_linear_381_316)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.5,
    cy: 181.188,
    rx: 111.5,
    ry: 67.5,
    fill: "#F9FAFB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.5,
    cy: 175.188,
    rx: 107.5,
    ry: 66.5,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4776 145.424L34.4809 145.393L34.4836 145.363L41.9836 62.8626L41.9875 62.8192L41.9905 62.7757C42.1222 60.8657 42.822 58.0031 44.33 55.7911C45.7044 53.7752 47.6389 52.3859 50.763 52.4943L212.648 65.4845C212.653 65.4849 212.658 65.4853 212.662 65.4858C214.558 65.657 217.656 66.7509 220.065 69.6132C222.389 72.3754 224.424 77.2104 223.528 85.5282L210.047 189.88C209.464 192.984 207.755 197.216 204.758 200.037C202.007 202.627 197.871 204.352 191.236 202.196L191.1 202.152L190.961 202.117L45.4608 166.118L45.1653 166.044L44.8622 166.017C43.1149 165.858 40.1461 164.79 37.814 161.868C35.5482 159.029 33.5627 154.023 34.4776 145.424Z",
    fill: "url(#paint1_linear_381_316)",
    stroke: "url(#paint2_linear_381_316)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126,
    cy: 43.5,
    rx: 39,
    ry: 43.5,
    fill: "#BB0478"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 43.5,
    rx: 39,
    ry: 43.5,
    fill: "#FF3BB8"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.5,
    cy: 44,
    rx: 30.5,
    ry: 33,
    fill: "#EF1CA3"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.5,
    cy: 44,
    rx: 30.5,
    ry: 33,
    fill: "#FF60C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M135.793 26.413L112.104 48.3447L105.27 38.7497C103.448 36.5566 101.17 37.2267 100.259 37.8359L97.0702 40.1204C94.1545 42.3136 94.9442 44.6895 95.7035 45.6033L105.726 59.3106C109.37 63.6969 113.622 61.7474 115.293 60.2244L141.26 36.0083C144.176 33.084 142.779 30.5254 141.716 29.6115L141.26 28.6976C138.709 25.4079 136.553 25.8038 135.793 26.413Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5001 83.0001C58.1001 82.6001 57.3334 86.8334 57.5001 89.0001L56.0001 105.5C55.6001 109.1 58.5001 110.333 60.0001 110.5L78.0001 113.5C81.6001 113.9 82.5001 110.667 82.5001 109L84.0001 90C84.4001 86.4 80.8335 85.1667 79.0001 85L62.5001 83.0001Z",
    fill: "url(#paint3_linear_381_316)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125 97.2844C125 96.0748 126.065 95.142 127.264 95.3019L198.264 104.769C199.258 104.901 200 105.749 200 106.751V113.655C200 114.885 198.899 115.824 197.684 115.629L126.684 104.269C125.714 104.114 125 103.277 125 102.295V97.2844Z",
    fill: "#6C63FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157 121.133C157 120.531 157.527 120.066 158.124 120.141L196.124 124.891C196.624 124.953 197 125.378 197 125.883V133.81C197 134.431 196.44 134.902 195.828 134.795L157.828 128.145C157.349 128.061 157 127.646 157 127.16V121.133Z",
    fill: "#6C63FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132 117.161C132 116.55 132.544 116.082 133.148 116.172L151.148 118.872C151.638 118.946 152 119.366 152 119.861V125.839C152 126.45 151.456 126.918 150.852 126.828L132.852 124.128C132.362 124.054 132 123.634 132 123.139V117.161Z",
    fill: "#6C63FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54 137.481C54 136.206 55.1783 135.256 56.4249 135.527L98.4249 144.658C99.3442 144.857 100 145.671 100 146.612V158.519C100 159.794 98.8217 160.744 97.5751 160.473L55.5751 151.342C54.6558 151.143 54 150.329 54 149.388V137.481Z",
    fill: "url(#paint4_linear_381_316)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70 145.241C70 144.603 70.5891 144.128 71.2124 144.264L92.2124 148.829C92.6721 148.929 93 149.336 93 149.806V154.759C93 155.397 92.4109 155.872 91.7876 155.736L70.7876 151.171C70.3279 151.071 70 150.664 70 150.194V145.241Z",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 178,
    cy: 165.5,
    rx: 14,
    ry: 14.5,
    fill: "#6C63FF"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160,
    cy: 161.5,
    rx: 14,
    ry: 14.5,
    fill: "#5F57E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_381_316",
    x1: 253,
    y1: 197.187,
    x2: 11.5,
    y2: 197.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_381_316",
    x1: -20.5,
    y1: 163.5,
    x2: 245,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_381_316",
    x1: 35.5,
    y1: 166,
    x2: 228,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D55E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8982FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_381_316",
    x1: 63.5,
    y1: 103.5,
    x2: 96,
    y2: 78.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C63FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_381_316",
    x1: 62,
    y1: 153,
    x2: 142,
    y2: 127.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149148,
    stopColor: "#6C63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C63FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment1);
export default __webpack_public_path__ + "static/media/Payment1.a39926065d8cb1cf1bfdc4762f77da49.svg";
export { ForwardRef as ReactComponent };